import {parseDecimal} from '../../../../utils/index.js';
import {centavosDoMembro} from './rendaInscricao.js';

/*
 * Adapta os valores do formulário do administrativo ao formato que o
 * BoxResumoInscricao da inscrição pública lê (o mesmo do InscricaoVO):
 * sim/não como boolean, vaga com a descrição, rendas do inscrito em `rendas`
 * e cada integrante com a renda bruta da soma das ocupações dele.
 *
 * opcoesVaga: [{valor, descricao}] da vaga escolhida ("Curso - Turno - Campus").
 */
export const montarResumoInscricao = (valores = {}, {opcoesVaga = []} = {}) => {
    const pessoa = valores.pessoa || {};
    const idVaga = valores.vaga === null || valores.vaga === undefined ? '' : String(valores.vaga);
    const vaga = opcoesVaga.find(opcao => String(opcao.valor) === idVaga);

    return {
        pessoa: {
            nome: pessoa.nome || '',
            nomeSocial: pessoa.habilitarNomeSocial ? (pessoa.nomeSocial || '') : '',
            nomeMae: pessoa.nomeMae || '',
            cpf: pessoa.cpf || '',
            emailAtual: pessoa.emailAtual || ''
        },
        declaracaoIR: valores.declaracaoIR || '',
        rendas: (valores.renda || []).map(renda => ({...renda, vlrRenda: parseDecimal(renda.vlrRenda) ?? 0})),
        composicaoFamiliar: (valores.composicaoFamiliar || []).map(membro => ({...membro, rendaBruta: centavosDoMembro(membro) / 100})),
        vlrPensao: valores.vlrPensao,
        vlrPensaoFilho: valores.vlrPensaoFilho,
        cadUnicoOuTransferenciaRenda: valores.cadUnicoOuTransferenciaRenda === 'true',
        sistemaCotas: valores.sistemaCotas === 'true',
        vaga: idVaga ? {id: idVaga, descricao: vaga ? vaga.descricao : ''} : null
    };
};
